class Modal {
  constructor() {
    this.container = document.getElementById("modal-bg");
    this.openModalBtn = document.querySelectorAll("#open-modal");
    this.searchResultBody = this.container.querySelector("#search-result__body");
    this.form = this.container.querySelector("form.searchform");
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.container.querySelector(".search-result_container");
    this.presetSearchContainer = this.container.querySelector(".search-preset_container");
    this.searchInputField = document.querySelector("#side-panel-search-input");
    this.closeModalBtn = document.getElementById("close-search-popup");
    // Bind the event listeners
    if (this.openModalBtn) {
      this.openModalBtn.forEach((btn) => btn.addEventListener("click", this.openModal.bind(this)));
    }
    this.container.addEventListener("click", this.closeModalOnClickOutside.bind(this));
    this.closeModalBtn.addEventListener("click", this.closeModal.bind(this));
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const trimmedValue = this.searchInputField.value.trim();
        if (trimmedValue !== "") {
          window.location.href = `/collections/shop?q=${encodeURIComponent(trimmedValue)}`;
        } else {
          alert("Search input cannot be empty!");
        }
      }
    });

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    // Add scroll listener to remove hover effects during scroll
    this.container.addEventListener("scroll", this.handleScroll.bind(this), { passive: true });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!this.predictiveSearchResults) return;
    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove("active");
      this.predictiveSearchResults.classList.add("hidden");
      this.presetSearchContainer.classList.remove("hidden");
      return;
    }
    this.predictiveSearchResults.classList.add("active");
    this.predictiveSearchResults.classList.remove("hidden");
    this.presetSearchContainer.classList.add("hidden");
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add("loading");

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,article,collection,query&${encodeURIComponent(
        "resources[limit]"
      )}=10&section_id=predictive-search`
    )
      .then((response) => {
        this.predictiveSearchResults.classList.remove("loading");
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    const submitButton = this.container.querySelector("#search-results-submit");

    if (submitButton) {
      submitButton.addEventListener("click", () => {
        this.form.submit();
      });
    }

    // Reinitialize Swiper after new content is loaded
    if (typeof Swiper !== "undefined") {
      const swiperElement = this.container.querySelector(".popup-search-swiper");
      if (swiperElement) {
        // Destroy existing Swiper instance if it exists
        if (swiperElement.swiper) {
          swiperElement.swiper.destroy();
        }

        // Initialize new Swiper instance
        new Swiper(".popup-search-swiper", {
          slidesPerView: 2,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          },
        });
      }
    }
  }

  openModal() {
    this.container.classList.remove("hidden");
    if (this.searchInputField) this.searchInputField.focus();
  }

  closeModal() {
    this.container.classList.add("hidden");
  }

  closeModalOnClickOutside(event) {
    if (event.target === this.container) {
      this.closeModal();
    }
  }

  handleScroll() {
    // Remove hover effects from all search menu items during scroll
    const searchMenuItems = this.container.querySelectorAll('.search-preset_container a');
    searchMenuItems.forEach(item => {
      item.style.pointerEvents = 'none';
    });

    // Re-enable pointer events after a short delay
    setTimeout(() => {
      searchMenuItems.forEach(item => {
        item.style.pointerEvents = 'auto';
      });
    }, 100);
  }
}

// Changed from window.load to DOMContentLoaded for earlier initialization.
// Remove the event listener and directly instantiate the Modal.
if (typeof Modal !== "undefined") {
  new Modal();
}
